import { ID, Currency } from './common';
import { Contrato } from './contrato';

// Payment methods available in the system
export const METODOS_PAGO = [
  'Efectivo',
  'Transferencia',
  'Cheque',
  'Débito Automático',
  'Depósito Bancario',
  'Tarjeta de Crédito',
  'Tarjeta de Débito'
] as const;

export const EstadoPago = {
  PENDIENTE: 'PENDIENTE',
  ATRASADO: 'ATRASADO',
  ADELANTADO: 'ADELANTADO',
  PAGADO: 'PAGADO',
  CANCELADO: 'CANCELADO',
} as const;
export type EstadoPago = typeof EstadoPago [keyof typeof EstadoPago];

export const TipoPago = {
  INQUILINO: 'INQUILINO',
  PROPIETARIO: 'PROPIETARIO',
} as const;
export type TipoPago = typeof TipoPago[keyof typeof TipoPago];

export interface Pago {
  base_alquiler_recibo?: number;
  desglose?: string | null;
  inquilino_agente_retencion_irpf?: boolean;
  id: ID;
  contrato_id: ID;
  tipo: TipoPago;
  fecha_limite: string; // YYYY-MM-DD
  monto: number;
  moneda: Currency;
  estado: EstadoPago;
  fecha_pago?: string | null;
  monto_pagado?: number | null;
  metodo_pago?: string | null;
  id_recibo?: string | null;
  dias_atraso?: number;
  es_reajuste?: boolean;
  notas?: string | null;
  registrado_por?: ID;
  contrato_cancelado?: boolean;
  // User-facing contract number returned by the payment detail endpoint
  numero_contrato?: string;
  created_at?: string;
  updated_at?: string;
  // Nested object populated by API
  contrato?: Contrato;
  // Computed fields
  monto_alquiler_propietario?: number;
  inquilino_nombre?: string;
  inquilino_documento?: string;
  propietario_nombre?: string;
  es_pago_parcial?: boolean;
  dias_ocupados?: number;
}

